export const KEEP_NUMBER_OPTION__KEEP_OTHER = 'keep-number-other';
export const KEEP_NUMBER_OPTION__KEEP = 'keep-number';
export const KEEP_NUMBER_OPTION__NEW = 'new';

export type KeepNumberOptions =
  | typeof KEEP_NUMBER_OPTION__KEEP_OTHER
  | typeof KEEP_NUMBER_OPTION__KEEP
  | typeof KEEP_NUMBER_OPTION__NEW;

export type NumberConfigState = {
  bundleId: number;
  cartItemId: number;
  keepNumberCodeInputValue: string; //porterings koden från input fältet
  keepNumberCodeSent: boolean; //porterings koden skickad
  keepNumberDevPortingCode: string; //porterings koden från servern
  keepNumberCodeValidated: boolean; //porterings koden godkänd
  keepNumberInputValue: string; //behåll nummer telefon nummret från input fältet
  keepNumberOption?: KeepNumberOptions;
  keepNumberShowError: boolean; //Should error be showed
  keepNumberInputFieldId?: string;
  ownerSocialSecurityNumber?: string; //ssn vid familj val behållnummret annan ägare
  hiddenNumber: boolean;
  esim: boolean;
  parentMsisdn?: string;
};
